module.exports = __webpack_public_path__ + "img/qc35LineUp.785035f6.jpg";